export const GENRES = [
  'Acoustic',
  'Alternative',
  'Ambient',
  'Dancehall',
  'Deep House',
  'Disco',
  'Drum and Bass',
  'Dubstep',
  'EDM',
  'Electronic',
  'Experimental',
  'Folk',
  'Funk',
  'Hip Hop/Rap',
  'House',
  'Indie',
  'Jazz',
  'Latin',
  'Lo-fi',
  'Metal',
  'Pop',
  'Punk',
  'R&B',
  'Reggae',
  'Reggaeton',
  'Rock',
  'Techno',
  'Trance',
  'Trap',
  'Trip Hop'
] as const

export type Genre = typeof GENRES[number]
